import { UPDATE_SALES_BY_STORE_WIDGET } from "./actionTypes"

export const updateSalesByStoreWidget = data => {
  return {
    type: UPDATE_SALES_BY_STORE_WIDGET,
    payload: data,
  }
}
